import React from 'react';
import PropTypes from 'prop-types';
import { Clock } from 'lucide-react';

import {
  formatTimeInStage,
  TIME_IN_STAGE_VISIBLE_STAGES,
} from 'helpers/timeInStage';
import styles from './TimeInStageBadge.module.scss';

const TimeInStageBadge = ({ stage, startedAt, now }) => {
  if (!TIME_IN_STAGE_VISIBLE_STAGES.includes(stage)) {
    return null;
  }

  const timeInStage = formatTimeInStage(startedAt, now);
  if (!timeInStage) {
    return null;
  }

  const toneClass = styles[timeInStage.tone] || styles.blue;

  return (
    <span
      className={`${styles.badge} ${toneClass}`}
      data-testid="time-in-stage-badge"
    >
      <Clock width={14} height={14} aria-hidden="true" />
      <strong className={styles.duration}>{timeInStage.label}</strong>
      <span className={styles.stageLabel}>in {stage} stage</span>
    </span>
  );
};

TimeInStageBadge.propTypes = {
  stage: PropTypes.string,
  startedAt: PropTypes.string,
  now: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date),
  ]),
};

export default TimeInStageBadge;
